import { apiPostRequest } from './apiClient';
import { captureException } from './sentry';

/**
 * ログアウト処理を行う関数
 */
export async function logout(): Promise<void> {
    try {
        // ログアウトAPI実行
        const response = await apiPostRequest('/logout', {});

        if (response?.status !== 200) {
            // Sentryにエラーを送信
            captureException(new Error('Failed to log out'));
        }
        // 応答に関わらずログインページにリダイレクト
        window.location.href = '/login';
    } catch (error) {
        // エラーが発生してもログインページにリダイレクト
        window.location.href = '/login';
    }
}
